import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface EmergencyRequestRecord {
  id: string;
  title: string;
  description: string;
  bloodTypesNeeded: unknown;
  quantityNeeded: unknown;
  urgencyLevel: string;
  status: string;
  expiresAt: string;
  contactNumber: string;
  createdAt: string;
  hospitalId: string;
  hospitalName: string;
  hospitalAddress: string;
  hospitalDistrict: string;
}

export const emergenciesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEmergencies: builder.query<EmergencyRequestRecord[], { status?: string; limit?: number } | void>({
      query: (args) => {
        const params = new URLSearchParams();
        if (args?.status) params.set("status", args.status);
        if (args?.limit) params.set("limit", String(args.limit));
        const qs = params.toString();
        return `/emergencies${qs ? `?${qs}` : ""}`;
      },
      transformResponse: (res: ApiResponse<{ emergencies: EmergencyRequestRecord[] }>) => res.data.emergencies,
      providesTags: ["Emergencies"],
    }),
  }),
});

export const { useGetEmergenciesQuery } = emergenciesApi;
